import splide, { customSplide } from "../utils/splide";

const services = document.getElementById("services");
if (services) {
    const servicesSplide = customSplide(services, {
        type: "slide",
        rewind: true,
        perPage: 4,
        autoplay: true,
        speed: 2000,
        gap: "20px",
        lazyLoad: "sequential",
        pagination: false,
        arrows: false,
        breakpoints: {
            1200: {
                perPage: 3,
                pagination: false,
                fixedHeight: "unset",
            },
            900: {
                perPage: 2,
                pagination: false,
                fixedHeight: "unset",
            },
            600: {
                perPage: 1,
                pagination: true,
                arrows: false,
                fixedHeight: false,
            },
        },
    });
    servicesSplide.mount();
}